import {
  type CookieCategoryId,
  getCategoryProviders,
} from '@lib/analytics/cookie-registry';
import CategoryRow from './category-row';
import {
  CATEGORIES,
  type ConsentCategoryConfig,
  ESSENTIAL_CATEGORY,
} from './constants';

type Preferences = Record<ConsentCategoryConfig['id'], boolean>;

type DetailsTabProps = {
  preferences: Preferences;
  onUpdate: (category: ConsentCategoryConfig['id'], value: boolean) => void;
};

const CONSENT_TO_REGISTRY: Record<
  ConsentCategoryConfig['id'],
  CookieCategoryId
> = {
  preferences: 'preferences',
  analytics: 'statistics',
  advertising: 'marketing',
};

const DetailsTab = ({ preferences, onUpdate }: DetailsTabProps) => (
  <div className="flex flex-col gap-3">
    <CategoryRow
      label={ESSENTIAL_CATEGORY.label}
      description={ESSENTIAL_CATEGORY.description}
      checked={true}
      alwaysActive
      providers={getCategoryProviders('necessary')}
    />
    {CATEGORIES.map((cat) => (
      <CategoryRow
        key={cat.id}
        label={cat.label}
        description={cat.description}
        checked={preferences[cat.id]}
        onChange={(val) => onUpdate(cat.id, val)}
        providers={getCategoryProviders(CONSENT_TO_REGISTRY[cat.id])}
      />
    ))}
    <div className="rounded-lg border border-brand-neutral-100 bg-white px-4 py-3">
      <p className="font-body text-sm leading-[1.5] text-brand-neutral-900">
        Cookie declaration last updated on 18/05/2026
      </p>
    </div>
  </div>
);

export default DetailsTab;
